module.exports = __webpack_public_path__ + "media/videored.e8f2d5cd.mp4";